import React from "react";
import {Field} from "react-final-form";
import {
    composeValidators,
    regRequiredValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {
    IdLabelInterface,
    UserPreferredSpecialization,
} from "../../../../containers/RegistrationLoginPage/types";

import SelectV2 from "../../../HTMLEntities/SelectV2";
import {SINGLE_SELECT} from "../../../HTMLEntities/SelectV2/utils";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";

interface UserCityFieldInterface {
    configuration: UserPreferredSpecialization;
}

/**
 * visible: boolean;
    editable: boolean;
    fieldName: string;
    loading: boolean;
    selectedValue: UserPreferredSpecializationItem | null;
    values: UserPreferredSpecializationItemGroup[] | null;

 */
const PreferredSpecialization: React.FC<UserCityFieldInterface> = ({
    configuration,
}: UserCityFieldInterface) => {
    const {fieldName, values: dropDownValues, selectedValue, editable} = configuration;

    // const defaultValue = selectedValue
    //     ? selectedValue
    //     : dropDownValues
    //     ? dropDownValues[0]
    //     : undefined;

    return (
        <Field<IdLabelInterface>
            name={fieldName}
            validate={composeValidators(
                regRequiredValidate("Please select preferred specialization"),
            )}
            {...(selectedValue ? {initialValue: selectedValue} : {})}
            validateFields={[]}
        >
            {(props) => {
                return (
                    <SelectV2
                        placeholder="Preferred Specializations"
                        type={SINGLE_SELECT}
                        items={dropDownValues ?? []}
                        inputRFF={props.input}
                        withSearch={true}
                        isFocused={props?.meta?.active ?? false}
                        isTouched={props?.meta?.touched}
                        error={errorHandler(props?.meta)}
                        isDisabled={!editable}
                        selectedOption={selectedValue ? [selectedValue] : undefined}
                        isFilled={typeof props.input.value === "object"}
                    />
                );
            }}
        </Field>
    );
};
export default PreferredSpecialization;
